import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Networks from "./Networks";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("networks")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Networks />
		</ThemeProvider>
	</StrictMode>
);
